import { mapWishlistItem } from '@shared/analytics/mapper'
import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onAddWishlistItemEvent,
  onRemoveWishlistItemEvent,
  removeAddWishlistItemEvent,
  removeRemoveWishlistItemEvent,
} from '@shared/event/events/wishlist'

const initWishlistEvents = (Analytics: GooglePlugin) => {
  const addWishlistItemToken = onAddWishlistItemEvent(({ wishlistItems }) => {
    Analytics.event({
      ecommerce_ga4: null,
    })
    Analytics.event({
      event: 'add_to_wishlist',
      ecommerce_ga4: {
        items: wishlistItems.map(mapWishlistItem),
        currency: wishlistItems[0].variants[0].currencyCode,
        value: wishlistItems[0].variants[0].price,
      },
    })
  })

  const removeWishlistItemToken = onRemoveWishlistItemEvent(
    ({ wishlistItems }) => {
      Analytics.event({
        ecommerce_ga4: null,
      })
      Analytics.event({
        event: 'remove_from_wishlist',
        ecommerce_ga4: {
          items: wishlistItems.map(mapWishlistItem),
          currency: wishlistItems[0].variants[0].currencyCode,
          value: wishlistItems[0].variants[0].price,
        },
      })
    }
  )

  return () => {
    removeAddWishlistItemEvent(addWishlistItemToken)
    removeRemoveWishlistItemEvent(removeWishlistItemToken)
  }
}

export default initWishlistEvents
